import StringConstants from "../constants/string-contants";
import AppRoutes from "../constants/routes";
import { BookingType } from "../versioning/page/HistoryPage/v2/components/booking-model-v2";

export default function RedirectToCard(benefitConfig: any) {
  let params = new URLSearchParams();

  switch (benefitConfig?.booking_type) {
    case BookingType.DELAYED:
      params.set(
        StringConstants.PARAM_BENEFIT_CONFIG_ID,
        benefitConfig?._id ?? ""
      );
      return `${AppRoutes.delayedBookingDetails}?${params}`;

    case `UNIQUE_COUPON`:
      params.set(
        StringConstants.PARAM_BENEFIT_CONFIG_ID,
        benefitConfig?._id ?? ""
      );
      return `${AppRoutes.benefitDetails}?${params}`;

    case `STATIC_COUPON`:
      params.set(
        StringConstants.PARAM_BENEFIT_CONFIG_ID,
        benefitConfig?._id ?? ""
      );
      return `${AppRoutes.benefitDetails}?${params}`;

    case `GOLF_BOOKING`:
      params.set(
        StringConstants.PARAM_BENEFIT_CONFIG_ID,
        benefitConfig?._id ?? ""
      );
      return `${AppRoutes.facility}?${params}`;

    case BookingType.AIRPORT_TRANSFER_BOOKING:
      params.set(
        StringConstants.PARAM_BENEFIT_CONFIG_ID,
        benefitConfig?._id ?? ""
      );
      return `${AppRoutes.delayedBookingDetails}?${params}`;

    case BookingType.QR_BOOKING:
      params.set(
        StringConstants.PARAM_BENEFIT_CONFIG_ID,
        benefitConfig?._id ?? ""
      );
      return `${AppRoutes.delayedBookingDetails}?${params}`;

    case BookingType.CUSTOM_DELAYED:
      params.set(
        StringConstants.PARAM_BENEFIT_CONFIG_ID,
        benefitConfig?._id ?? ""
      );
      return `${AppRoutes.delayedBookingDetails}?${params}`;

    case "LISTING_V2":
      params.set(
        StringConstants.PARAM_BENEFIT_CONFIG_ID,
        benefitConfig?._id ?? ""
      );
      params.append(
        StringConstants.PARAM_CATEGORY_ID,
        benefitConfig?.category_id ?? ""
      );
      return `${AppRoutes.listing}?${params}`;

    case "LISTING":
      params.set(
        StringConstants.PARAM_BENEFIT_CONFIG_ID,
        benefitConfig?._id ?? ""
      );
      params.append(
        StringConstants.PARAM_CATEGORY_ID,
        benefitConfig?.category_id ?? ""
      );
      return `${AppRoutes.benefitDetails}?${params}`;

    case "ONE_VASCO":
      params.set(
        StringConstants.PARAM_BENEFIT_CONFIG_ID,
        benefitConfig?._id ?? ""
      );
      params.append(
        StringConstants.PARAM_CATEGORY_ID,
        benefitConfig?.category_id ?? ""
      );
      return `${AppRoutes.benefitDetails}?${params}`;

    case BookingType.PADDLE_BOOKING:
      params.set(
        StringConstants.PARAM_BENEFIT_CONFIG_ID,
        benefitConfig?._id ?? ""
      );
      return `${AppRoutes.delayedBookingDetails}?${params}`;

    case "VALET_BOOKING":
      params.set(
        StringConstants.PARAM_BENEFIT_CONFIG_ID,
        benefitConfig?._id ?? ""
      );
      return `${AppRoutes.facility}?${params}`;

    case BookingType.GOLF_BOOKING:
      params.set(
        StringConstants.PARAM_BENEFIT_CONFIG_ID,
        benefitConfig?._id ?? ""
      );
      return `${AppRoutes.facility}?${params}`;

    default:
      return "";
  }
}
